import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  arrow: {
    transform: 'rotate(180deg)',
    transition: 'transform 0.3s',
  },
  arrowOpen: {
    transform: 'rotate(0deg)',
  },
  draftChip: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.white,
  },
}))

export default useStyles
